<template>
    <div>
        <h1>Übungen zu den einzelnen Themen</h1>
        Die Lösungen befinden sich am unteren Ende der Seite.
        <br /><br />

        <collapsible title="Aldehyde">
            Zu diesem Thema gibt es leider noch keine Übungen 🙁.
        </collapsible>

        <collapsible title="Alkane">
            <ol>
                <li>
                    Nenne die homologe Reihe der Alkane rückwärts von 10 C-Atome
                    bis 1 C-Atom:
                </li>
                <li>Nenne drei Eigenschaften der Alkane:</li>
                <li>Wie lautet die allgemeine Strukturformel der Alkane?</li>
                <li>
                    Finde den korrekten Wert für <b>x</b>:
                    <ol>
                        <li>
                            C<sub>6</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub>14</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub>38</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub><b>x</b></sub
                            >H<sub>24</sub>
                        </li>
                        <li>
                            C<sub><b>x</b></sub
                            >H<sub>4</sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Korrigiere die folgenden Aussagen:
                    <ol>
                        <li>Nonan = C<sub>9</sub>H<sub>22</sub></li>
                        <li>Heptan = C<sub>6</sub>H<sub>14</sub></li>
                        <li>Butan = C<sub>3</sub>H<sub>12</sub></li>
                    </ol>
                </li>
                <li>
                    Welche Bindungsart liegt zwischen den Kohlenstoffen in
                    Alkanen vor?
                </li>
                <li>
                    Ordne nach Siedetemperatur (steigend):
                    <ul>
                        <li>Butan</li>
                        <li>C<sub>12</sub>H<sub>x</sub></li>
                        <li>Nonan</li>
                        <li>C<sub>8</sub>H<sub>18</sub></li>
                        <li>C<sub>x</sub>H<sub>12</sub></li>
                    </ul>
                </li>
                <li>
                    Benenne die folgenden Alkane:
                    <ol>
                        <li>
                            <img
                                src="@/assets/img/stoffe/uebungen/alkane-1.png"
                                alt=""
                            />
                        </li>
                        <li>
                            <img
                                src="@/assets/img/stoffe/uebungen/alkane-2.png"
                                alt=""
                            />
                        </li>
                    </ol>
                </li>
                <li>
                    Bestimme die Reaktionsgleichung und den Reaktionstypen von
                    <code>Butan + Brom</code> unter Lichteinfluss.
                </li>
            </ol>
        </collapsible>

        <collapsible title="Alkene">
            <ol>
                <li>
                    Benenne folgende n-Alkene:
                    <ol>
                        <li>3 C-Atome</li>
                        <li>7 C-Atome</li>
                        <li>4 C-Atome</li>
                        <li>9 C-Atome</li>
                        <li>8 C-Atome</li>
                        <li>1 C-Atom</li>
                    </ol>
                </li>
                <li>Nenne 3 Eigenschaften der Alkene:</li>
                <li>Wie lautet die allgemeine Strukturformel der Alkene?</li>
                <li>
                    Finde den korrekten Wert für <b>x</b> (Es ist nur eine
                    Doppelbindung pro Alken vorhanden):
                    <ol>
                        <li>
                            C<sub>6</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub>14</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub>38</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub><b>x</b></sub
                            >H<sub>24</sub>
                        </li>
                        <li>
                            C<sub><b>x</b></sub
                            >H<sub>4</sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Korrigiere die folgenden Aussagen:
                    <ol>
                        <li>Nonen = C<sub>9</sub>H<sub>16</sub></li>
                        <li>Hepten = C<sub>8</sub>H<sub>16</sub></li>
                        <li>Buten = C<sub>3</sub>H<sub>8</sub></li>
                    </ol>
                </li>
                <li>
                    Welche Bindungsarten liegen zwischen den Kohlenstoffen vor?
                </li>
                <li>
                    Ordne nach Siedetemperatur (steigend):
                    <ul>
                        <li>Buten</li>
                        <li>C<sub>12</sub>H<sub>x</sub></li>
                        <li>Nonen</li>
                        <li>C<sub>8</sub>H<sub>16</sub></li>
                        <li>C<sub>x</sub>H<sub>10</sub></li>
                    </ul>
                </li>
                <li>Benenne das folgende Molekül:</li>
                <img src="@/assets/img/stoffe/uebungen/alkene-1.png" alt="" />
                <li>
                    Beschreibe die Nachweisreaktion für Alkene und ihren
                    Reaktionsytypen anhand von Penten:
                </li>
            </ol>
        </collapsible>

        <collapsible title="Alkine">
            <ol>
                <li>
                    Nenne alle Alkine mit ungerader Anzahl an C-Atomen bis 10:
                </li>
                <li>Nenne drei Eigenschaften der Alkine:</li>
                <li>Wie lautet die allgemeine Strukturformel der Alkine?</li>
                <li>
                    Finde den korrekten Wert für <b>x</b>:
                    <ol>
                        <li>
                            C<sub>6</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub>14</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub>38</sub>H<sub><b>x</b></sub>
                        </li>
                        <li>
                            C<sub><b>x</b></sub
                            >H<sub>24</sub>
                        </li>
                        <li>
                            C<sub><b>x</b></sub
                            >H<sub>4</sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Korrigiere die folgenden Aussagen:
                    <ol>
                        <li>Nonin = C<sub>9</sub>H<sub>22</sub></li>
                        <li>Heptin = C<sub>6</sub>H<sub>10</sub></li>
                        <li>Butin = C<sub>3</sub>H<sub>8</sub></li>
                    </ol>
                </li>
                <li>
                    Ordne nach Siedetemperatur (steigend):
                    <ul>
                        <li>Butin</li>
                        <li>C<sub>12</sub>H<sub>x</sub></li>
                        <li>Nonin</li>
                        <li>C<sub>8</sub>H<sub>14</sub></li>
                        <li>C<sub>x</sub>H<sub>8</sub></li>
                    </ul>
                </li>
                <li>Benenne das folgende Molekül:</li>
                <img src="@/assets/img/stoffe/uebungen/alkine-1.png" alt="" />
                <li>
                    Beschreibe die Reaktionsgleichungen in denen aus einem Alkin
                    erst ein Halogenalken und dann ein Halogenalkan entsteht.
                    Benenne deren Reaktionstyp:
                </li>
            </ol>
        </collapsible>

        <hr class="chapter-split" />
        <h1>Lösungen zu den Übungen</h1>

        <collapsible title="Aldehyde">
            Zu diesen Übungen gibt es leider noch keine Lösungen 🙁.
        </collapsible>

        <collapsible title="Alkane">
            <ol>
                <li>
                    Nenne die homologe Reihe der Alkane rückwärts von 10 C-Atome
                    bis 1 C-Atom:<br />
                    <b>Lösung:</b>&nbsp;Decan, Nonan, Octan, Heptan, Hexan,
                    Pentan, Butan, Propan, Ethan, Methan
                </li>
                <li>
                    Nenne drei Eigenschaften der Alkane:<br />
                    <b>Lösung:</b>&nbsp;gesättigt, hydrophob, lipohil, brennbar.
                </li>
                <li>
                    Wie lautet die allgemeine Strukturformel der Alkane?<br />
                    <b>Lösung:</b>&nbsp;C<sub>n</sub>H<sub>2n+2</sub>
                </li>
                <li>
                    Finde den korrekten Wert für <b>x</b>:
                    <ol>
                        <li>
                            C<sub>6</sub>H<sub><b>14</b></sub>
                        </li>
                        <li>
                            C<sub>14</sub>H<sub><b>30</b></sub>
                        </li>
                        <li>
                            C<sub>38</sub>H<sub><b>78</b></sub>
                        </li>
                        <li>
                            C<sub><b>11</b></sub
                            >H<sub>24</sub>
                        </li>
                        <li>
                            C<sub><b>1</b></sub
                            >H<sub>4</sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Korrigiere die folgenden Aussagen:
                    <ol>
                        <li>
                            Nonan = C<sub>9</sub>H<sub><b>20</b></sub>
                        </li>
                        <li><b>Hexan</b> = C<sub>6</sub>H<sub>14</sub></li>
                        <li>
                            Butan = C<sub>3</sub>H<sub><b>8</b></sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Welche Bindungsart liegt zwischen den Kohlenstoffen in
                    Alkanen vor?<br />
                    <b>Lösung:</b>&nbsp;Einfachbindungen, Sigma-Bindungen
                </li>
                <li>
                    Ordne nach Siedetemperatur (steigend):
                    <ol>
                        <li>Butan</li>
                        <li>C<sub>x</sub>H<sub>12</sub></li>
                        <li>C<sub>8</sub>H<sub>18</sub></li>
                        <li>Nonan</li>
                        <li>C<sub>12</sub>H<sub>x</sub></li>
                    </ol>
                </li>
                <li>
                    Benenne die folgenden Alkane:
                    <ol>
                        <li>Heptan</li>
                        <li>2-Methyl-Propan</li>
                    </ol>
                </li>
                <li>
                    Bestimme die Reaktionsgleichung und den Reaktionstypen von
                    <code>Butan + Brom</code> unter Lichteinfluss.<br />
                    <b>Lösung:</b>&nbsp;<router-link
                        to="/reaktionen/radikalische-substitution"
                        >Radikalische Subsitution</router-link
                    >, C<sub>4</sub>H<sub>10</sub> + Br<sub>2</sub> →
                    C<sub>4</sub>H<sub>9</sub>Br + HBr
                    <img
                        src="@/assets/img/stoffe/uebungen/loesungen/c4h10+br2.png"
                        alt="C4H10+Br2→C4H9Br+HBr"
                        title="C4H10+Br2→C4H9Br+HBr"
                    />
                </li>
            </ol>
        </collapsible>

        <collapsible title="Alkene">
            <ol>
                <li>
                    Benenne folgende n-Alkene:
                    <ol>
                        <li><b>3 C-Atome:</b>&nbsp;Propen</li>
                        <li><b>7 C-Atome:</b>&nbsp;Hepten</li>
                        <li><b>4 C-Atome:</b>&nbsp;Buten</li>
                        <li><b>9 C-Atome:</b>&nbsp;Nonen</li>
                        <li><b>8 C-Atome:</b>&nbsp;Octen</li>
                        <li><b>1 C-Atom:</b>&nbsp;Geht nicht!</li>
                    </ol>
                </li>
                <li>
                    Nenne 3 Eigenschaften der Alkene:<br />
                    <b>Lösung:</b>&nbsp;gesättigt, hydrophob, lipohil, brennbar.
                </li>
                <li>
                    Wie lautet die allgemeine Strukturformel der Alkene?<br />
                    <b>Lösung:</b>&nbsp;C<sub>n</sub>H<sub>2n</sub>
                </li>
                <li>
                    Finde den korrekten Wert für <b>x</b> (Es ist nur eine
                    Doppelbindung pro Alken vorhanden):
                    <ol>
                        <li>
                            C<sub>6</sub>H<sub><b>12</b></sub>
                        </li>
                        <li>
                            C<sub>14</sub>H<sub><b>28</b></sub>
                        </li>
                        <li>
                            C<sub>38</sub>H<sub><b>76</b></sub>
                        </li>
                        <li>
                            C<sub><b>12</b></sub
                            >H<sub>24</sub>
                        </li>
                        <li>
                            C<sub><b>2</b></sub
                            >H<sub>4</sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Korrigiere die folgenden Aussagen:
                    <ol>
                        <li>
                            Nonen = C<sub>9</sub>H<sub><b>18</b></sub>
                        </li>
                        <li><b>Octen</b> = C<sub>8</sub>H<sub>16</sub></li>
                        <li>
                            Buten = C<sub><b>4</b></sub
                            >H<sub>8</sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Welche Bindungsarten liegen zwischen den Kohlenstoffen
                    vor?<br />
                    <b>Lösung:</b>
                    <ul>
                        <li>Einfachbindungen: Sigma-Bindungen</li>
                        <li>Doppelbindung(en): Sigma- & Pi-Bindung(en)</li>
                    </ul>
                </li>
                <li>
                    Ordne nach Siedetemperatur (steigend):
                    <ol>
                        <li>Buten</li>
                        <li>C<sub>x</sub>H<sub>10</sub></li>
                        <li>C<sub>8</sub>H<sub>16</sub></li>
                        <li>Nonen</li>
                        <li>C<sub>12</sub>H<sub>x</sub></li>
                    </ol>
                </li>
                <li>
                    Benenne das folgende Molekül:<br />
                    <b>Lösung:</b>&nbsp;2,7-Dimethyl-4-Propyl-Non-3,6-dien
                </li>
                <li>
                    Beschreibe die Nachweisreaktion für Alkene und ihren
                    Reaktionsytypen anhand von Penten:<br />
                    <b>Lösung:</b>
                    <ul>
                        <li>
                            <router-link to="/reaktionen/elektrophile-addition"
                                >Elektrophile Addition</router-link
                            >
                        </li>
                        <li>
                            Brom reagiert bei Standardbedingungen mit Penten =>
                            es entsteht ein Halogenkohlenwasserstoff
                            (Bromidpentan)
                        </li>
                    </ul>
                </li>
            </ol>
        </collapsible>

        <collapsible title="Alkine">
            <ol>
                <li>
                    Nenne alle Alkine mit ungerader Anzahl an C-Atomen bis
                    10:<br />
                    <b>Lösung:</b>&nbsp;Propin, Pentin, Heptin, Nonin
                </li>
                <li>
                    Nenne drei Eigenschaften der Alkine:<br />
                    <b>Lösung:</b>&nbsp;gesättigt, hydrophob, lipohil, brennbar.
                </li>
                <li>
                    Wie lautet die allgemeine Strukturformel der Alkine?<br />
                    <b>Lösung:</b>&nbsp;C<sub>n</sub>H<sub>2n-2</sub>
                </li>
                <li>
                    Finde den korrekten Wert für <b>x</b>:
                    <ol>
                        <li>
                            C<sub>6</sub>H<sub><b>10</b></sub>
                        </li>
                        <li>
                            C<sub>14</sub>H<sub><b>26</b></sub>
                        </li>
                        <li>
                            C<sub>38</sub>H<sub><b>74</b></sub>
                        </li>
                        <li>
                            C<sub><b>13</b></sub
                            >H<sub>24</sub>
                        </li>
                        <li>
                            C<sub><b>3</b></sub
                            >H<sub>4</sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Korrigiere die folgenden Aussagen:
                    <ol>
                        <li>
                            Nonin = C<sub>9</sub>H<sub><b>16</b></sub>
                        </li>
                        <li><b>Hexin</b> = C<sub>6</sub>H<sub>10</sub></li>
                        <li>
                            Butin = C<sub>3</sub>H<sub><b>4</b></sub>
                        </li>
                    </ol>
                </li>
                <li>
                    Ordne nach Siedetemperatur (steigend):
                    <ol>
                        <li>Butin</li>
                        <li>C<sub>x</sub>H<sub>8</sub></li>
                        <li>C<sub>8</sub>H<sub>14</sub></li>
                        <li>Nonin</li>
                        <li>C<sub>12</sub>H<sub>x</sub></li>
                    </ol>
                </li>
                <li>
                    Benenne das folgende Molekül:<br />
                    <b>Lösung:</b>&nbsp;3,3-Diethyl-5-Methyl-Hexin
                </li>
                <li>
                    Beschreibe die Reaktionsgleichungen in denen aus einem Alkin
                    erst ein Halogenalken und dann ein Halogenalkan entsteht.
                    Benenne deren Reaktionstyp:<br />
                    <b>Lösung:</b>
                    <ol>
                        <li>
                            <router-link to="/reaktionen/elektrophile-addition"
                                >Elektrophile Addition</router-link
                            >
                            =>
                            <router-link to="halogenalkene"
                                >Halogenalken</router-link
                            >
                        </li>
                        <li>
                            Hydrohalogenierung =>
                            <router-link to="halogenalkane"
                                >Halogenalkan</router-link
                            >
                        </li>
                    </ol>
                </li>
            </ol>
        </collapsible>
    </div>
</template>
<script>
import Collapsible from '../../components/collapsible';
export default {
    components: { Collapsible },
};
</script>
